import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps3/fund-assets/api/search'
});

const getFunds = () => httpClient.get('/init', { params: { types: 'ALAPKEZELO,INGATLAN' } });

export const useFundSearchApi = () => ({ getFunds });
